"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPage = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Factory_1 = require("../Factory");
const UI_1 = require("../util/UI");
class AdminPage {
    constructor(remote) {
        this.remote = null;
        this.remote = remote;
    }
    renderPage(pageName, opts) {
        Log_1.default.info("AdminPage::renderPage( " + pageName + ", ... ) - default implementation");
    }
    pushPage(pageName, opts) {
        Log_1.default.info("AdminPage::pushPage( " + pageName + ", ... ) - start");
        if (typeof opts !== "object") {
            opts = {};
        }
        if (pageName.startsWith("./")) {
            pageName = pageName.substring(2);
            return UI_1.UI.pushPage(pageName, opts);
        }
        else {
            const prefix = Factory_1.Factory.getInstance().getHTMLPrefix();
            return UI_1.UI.pushPage(prefix + "/" + pageName, opts);
        }
    }
}
exports.AdminPage = AdminPage;
